import React from 'react';
import './main.css';
import Header from './Header';

function App() {
  return (
    <>
      <Header />
    </>
  );
}

export default App;
